/*global _ */
import {name, mixins, props, data, defaultFormFields, validationsRules, defaultSections, EventBus} from './config'

export default {
  name,
  mixins,
  props,

  data() {
    return {
      ...data,
      fields: {
        number: this.number || null,
        cvv: this.cvv || null,
      },
      showInfoModal: false,
      isNumberInfo: false,
      showResendModal: false,
      showBalanceModal: false,
      recoverSuccess: false,
      showingBalance: false,
      card: null,
    }
  },
  watch: {
    resendModalSuccess(newVal) {
      this.recoverSuccess = newVal
    }
  },

  computed: {
    infoTitle() {
      return this.isNumberInfo ?  this.numberInfoModalTitle : this.codeInfoModalTitle
    },
    infoHeaderText() {
      return this.isNumberInfo ? this.numberInfoModalHeader : this.codeInfoModalHeader
    },
    infoFooterText() {
      return this.isNumberInfo ? this.numberInfoModalFooter : this.codeInfoModalFooter
    },
    infoImgSrc() {
      return this.isNumberInfo ? this.numberInfoModalImgSrc : this.codeInfoModalImgSrc
    },
    displayResendModal() {
      return this.showResendLink && this.showResendModal
    },
    hasCard() {
      return  !_.isEmpty(this.card)
    },
    displayBalanceModal() {
      return false;//this.showBalanceModal && this.hasCard
    },
    balance() {
      if (!this.hasCard) {
        return 0
      }
      const card = this.card
      return card.balance ? card.balance : (((1 * card.cash) || 0) + ((1 * card.bonus_cash) || 0))
    },
    balanceComponentName() {
      return this.balanceComponent || 're-blank-component'
    }
  },

  created() {
    this.setupForm(validationsRules, defaultFormFields)
  },
  methods: {
    async getBalance() {
      this.resetFieldsValidation()
      this.formSubmitting = true
      EventBus.$emit('card.before.check-balance')
      this.$v.$touch()
      this.formSubmitting = true
      if (!this.isAnyInvalid) {
        const fields = _.clone(this.fields)
        this.$emit('checkBalance', fields)
        EventBus.$emit('card.check-balance', fields)
        try {
          const [data] = await this.promise('card.get', fields)
          const card = _.get(data, 'data', data)
          Vue.set(this, 'card', card)
          if (!_.isEmpty(data)) {
            this.showBalance()
            this.emit('card.check-balance.success', card, fields)
          } else {
            const e = this.$$t('error.general', "Error while retrieving balance. Please try again.")
            throw new Error(e)
          }
        } catch (e) {
          this.showFormError(e, {'scrollTo': '.re-card-balance-box', flattenTopMessages: true})
          this.emit('card.check-balance.error', e)
        } finally {
          this.emit('card.check-balance.end', fields)
        }

      } else {
        this.scrollToFirstErrorElement()
      }
    },
    getBalanceSections(card) {
      const sections = this.parseDynamicSections(
        this.$$s('balance.sections', defaultSections),
        {card},
        'balance.sections'
      )
      const type = _.get(card, 'data.type',  _.get(card, 'type', 'giftcard'))
      return _.pick(sections, [type])
    },
    showForm() {

    },
    hideForm() {

    },
    resetAll() {
      this.card = null
      this.resetForm()
      this.hideBalance()
    },
    showBalance() {
      this.showingBalance = true
      EventBus.$emit('card.check-balance.showing')
    },
    hideBalance() {
      this.showingBalance = false
      this.showBalanceModal = false
      EventBus.$emit('card.check-balance.another-card')
    },
    whatIsNumber() {
      this.showInfoModal = true
      this.isNumberInfo = true
      EventBus.$emit('card.open.info.number')
    },
    whatIsCode() {
      this.showInfoModal = true
      this.isNumberInfo = false
      EventBus.$emit('card.open.info.code')
    },
    closeInfoModal () {
      this.showInfoModal = false
      this.isNumberInfo = false
    },
    openResendModal() {
      this.showResendModal = true
      EventBus.$emit('card.open.resend-code')
    },
    closeResendModal() {
      this.showResendModal = false
      this.recoverSuccess = false
    },
    recoverByEmail(data) {
      this.$emit('recoverByEmail', data)
      EventBus.$emit('card.check-balance.resend-code.by-email', data)
    },
    recoverByNumber(data) {
      this.$emit('recoverByNumber', data)
      EventBus.$emit('card.check-balance.resend-code.by-number', data)
    }
  },
}
